module.exports = __webpack_public_path__ + "static/media/storyboarding.52aa742f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/work/storyboarding.png
// module id = 395
// module chunks = 1